module.exports = __webpack_public_path__ + "static/blackGif-80f4b4c09340c2e7c46ca4254a14d9ff.gif";